<template>
  <div class="sp-template plate-template order-plate-template">
    <div class="h-title">编辑订单</div>
    <el-card class="box-card">
      <div class="plate-content">
        <el-form :model="orderForm.deliveryDetail" size="small" :rules="orderFormRule" ref="orderForm1" 
          class="new-order__form" :label-width="formLabelWidth">
            <el-form-item label="取件方式">
              <el-tooltip effect="dark" content="我们将在1-2天内上门取件，为收货方便，请提前准备好货物！当运费小于500元时，按货物重量收取费用" placement="top-start">
                <el-radio v-model="orderForm.deliveryDetail.deliveryType" @change="changedeliveryType" label="PICK_UP_FROM_CUSTOMER">预约上门取件</el-radio>
              </el-tooltip>
              <el-tooltip effect="dark" content="请根据您的货物地址，选择距离货物最近的收货仓库" placement="top-start">
                <el-radio v-model="orderForm.deliveryDetail.deliveryType" @change="changedeliveryType" label="DELIVERY">送货至仓库</el-radio>
              </el-tooltip>
              <el-tooltip effect="dark" content="请根据您的货物地址，选择距离货物最近的收货仓库" placement="top-start">
                <el-radio v-model="orderForm.deliveryDetail.deliveryType" @change="changedeliveryType" label="DELIVERY_BY_EXPRESS">快递至仓库</el-radio>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="取件地址" v-show="orderForm.deliveryDetail.deliveryType == 'PICK_UP_FROM_CUSTOMER'">
              <div class="pickup-content">
                <p class="pickup-button">
                  <el-button size="mini" type="text" @click="addressFormVisible = true">编辑地址</el-button>
                </p>
                <ul class="pickup-address">
                  <li>{{orderForm.deliveryDetail.province}}</li>
                  <li>{{orderForm.deliveryDetail.city}}</li>
                  <li>{{orderForm.deliveryDetail.addressFirst}}</li>
                  <li>{{orderForm.deliveryDetail.contractName}}</li>
                  <li>{{orderForm.deliveryDetail.phone}}</li>
                </ul>
              </div>
            </el-form-item>
            <el-form-item label="交货仓库地址">
              <div class="pickup-content">
                <el-select v-model="warehouseId" filterable v-if="flag" placeholder="请选择" @change="selectWarehouse">
                  <el-option v-for="item in warehouse" :key="item.id" :label="item.title" :value="item.id"></el-option>
                </el-select>
                <ul class="pickup-address">
                  <li>{{userCarry[0].title}}</li>
                  <li>{{userCarry[0].address}}</li>
                  <li>{{userCarry[0].name}}</li>
                  <li>{{userCarry[0].phone}}</li>
                </ul>
              </div>
            </el-form-item>
            <el-form-item :label="orderForm.deliveryDetail.deliveryType == 'PICK_UP_FROM_CUSTOMER' ? '预约取件时间' : '预计送达时间'" 
              v-show="orderForm.deliveryDetail.deliveryType!='DELIVERY_BY_EXPRESS'" prop="appointmentAt">
              <!-- <div class="pickup-time">
                <p>预计&nbsp;&nbsp;7月12日[周四]09:00-15:00&nbsp;&nbsp;取件</p> 
                <a href="#" @click.prevent="setupPickupTime">修改</a>
              </div> -->
              <el-date-picker v-model="orderForm.deliveryDetail.appointmentAt" 
                :picker-options="appointmentAtOptions" 
                type="datetime" placeholder="选择日期" value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="快递公司" v-show="orderForm.deliveryDetail.deliveryType == 'DELIVERY_BY_EXPRESS'" prop="expressCompany">
              <el-input v-model="orderForm.deliveryDetail.expressCompany" auto-complete="off" placeholder="快递公司"></el-input>
            </el-form-item>
            <el-form-item label="快递单号" v-show="orderForm.deliveryDetail.deliveryType == 'DELIVERY_BY_EXPRESS'" prop="expressNumber">
              <el-input v-model="orderForm.deliveryDetail.expressNumber" auto-complete="off" placeholder="快递单号"></el-input>
            </el-form-item>
            
        </el-form>
      </div>
      <!-- 订单信息 -->
      <div class="plate-content">
        <div class="plate-content__title">
          <span class="title">订单信息</span>
          <!-- <el-checkbox style="margin-left:20px;" v-model="fbaChecked" @change="changeShippingAddressType">FBA地址</el-checkbox> -->
        </div>
        <el-form :model="orderForm.shippingDetail" size="small" :rules="orderFormRule2" ref="orderForm2" 
          class="new-order__form" :label-width="formLabelWidth">
            <div v-show="!fbaChecked">
              <div class="inline-flex">
                <div>
                  <el-form-item label="客户单号" prop="customerOrderNumber">
                    <el-input v-model="orderForm.customerRefnumber.customerOrderNumber" auto-complete="off" placeholder="由系统提供，可修改"></el-input>
                  </el-form-item>
                  <el-form-item label="联系人" prop="shippingContractName">
                    <el-input v-model="orderForm.shippingDetail.contractName" auto-complete="off" placeholder="如已存在联系人，则自动补充后面信息"></el-input>
                  </el-form-item>
                  <el-form-item label="国家" prop="shippingCountry">
                    <el-select v-model="shippingDetail.countryId" @change="queryProvince" filterable>
                      <el-option v-for="(country,i) in initialDataCountry" :key="i" :label="country.code" :value="country.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="城市" prop="shippingCity">
                    <el-select v-model="shippingDetail.cityId" @change="selectCity" filterable>
                      <el-option v-for="(city,i) in initialDataCity" :key="i" :label="city.nameEn" :value="city.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="详细地址1" prop="shippingAddressFirst">
                    <el-input type="textarea" v-model="orderForm.shippingDetail.addressFirst" auto-complete="off"></el-input>
                  </el-form-item>
                </div>
                <div>
                  <el-form-item label="产品名称" prop="product">
                    <el-select v-model="orderForm.product" filterable @change="changeChannel">
                      <el-option v-for="(p,i) in channelData" :key="i" :label="p.name" :value="p.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="联系电话" prop="shippingPhone">
                    <el-input v-model="orderForm.shippingDetail.phone" auto-complete="off" placeholder="联系电话"></el-input>
                  </el-form-item>
                  <el-form-item label="州/省" prop="shippingProvince">
                    <el-select v-model="shippingDetail.provinceId" @change="queryCity" filterable>
                      <el-option v-for="(province, i) in initialDataProvince" :key="i" :label="province.nameEn" :value="province.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="目的邮编" prop="zipcode">
                    <el-input v-model="orderForm.shippingDetail.zipcode" auto-complete="off" placeholder="目的邮编"></el-input>
                  </el-form-item>
                  <el-form-item label="详细地址2" prop="shippingAddressSecond">
                    <el-input type="textarea" v-model="orderForm.shippingDetail.addressSecond" auto-complete="off"></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
            <div class="inline-flex" v-show="fbaChecked">
              <div>
                <el-form-item label="客户单号">
                  <el-input v-model="orderForm.customerRefnumber.customerOrderNumber" auto-complete="off" placeholder="由系统提供，可修改"></el-input>
                </el-form-item>
                <el-form-item label="产品名称" prop="product">
                  <el-select v-model="orderForm.productId" filterable @change="changeChannel">
                    <el-option v-for="(p,i) in channelData" :key="i" :label="p.name" :value="p.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="联系人" prop="shippingContractName">
                  <el-input v-model="orderForm.shippingDetail.contractName" auto-complete="off" placeholder="如已存在联系人，则自动补充后面信息"></el-input>
                </el-form-item>
                <el-form-item label="目的国家" prop="shippingCountry">
                  <el-input v-model="orderForm.shippingDetail.country" auto-complete="off" placeholder="根据仓码自动匹配"></el-input>
                </el-form-item>
                <el-form-item label="目的城市" prop="shippingCity">
                  <el-input v-model="orderForm.shippingDetail.city" auto-complete="off" placeholder="根据仓码自动匹配，可修改"></el-input>
                </el-form-item>
                <el-form-item label="详细地址" prop="shippingAddressFirst">
                  <el-input type="textarea" v-model="orderForm.shippingDetail.addressFirst" auto-complete="off" v-on:input="queryFbaByAdressOrZipcode"></el-input>
                </el-form-item>
                <el-form-item label="详细地址2" prop="shippingAddressSecond">
                  <el-input type="textarea" v-model="orderForm.shippingDetail.addressSecond" auto-complete="off"></el-input>
                </el-form-item>

                <el-form-item label="Amazon Reference ID" prop="amazonReferenceId">
                  <el-input v-model="orderForm.amazonReferenceId" auto-complete="off"></el-input>
                </el-form-item>
                
              </div>
              <div>
                <el-form-item label="公司名称" >
                  <el-input v-model="orderForm.shippingDetail.companyName" auto-complete="off" placeholder="公司名称"></el-input>
                </el-form-item>
                <el-form-item label="FBA仓码">
                  <el-select v-model="orderForm.shippingDetail.fbaWarehouseCode" @change="changeFbaWarehouseCode" filterable>
                    <el-option v-for="(fba,i) in initialDataFbaAddress" :key="i" :label="fba.warehouseCode" :value="fba.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="FBA号">
                  <el-input v-model="orderForm.customerRefnumber.fbaNumber" auto-complete="off" placeholder="FBA号"></el-input>
                </el-form-item>
                <el-form-item label="联系电话" prop="shippingPhone">
                  <el-input v-model="orderForm.shippingDetail.phone" auto-complete="off" placeholder="联系电话"></el-input>
                </el-form-item>
                <el-form-item label="省/州" prop="shippingProvince2">
                  <el-input v-model="orderForm.shippingDetail.province" auto-complete="off" placeholder="根据仓码自动匹配"></el-input>
                </el-form-item>
                <el-form-item label="目的邮编" prop="zipcode">
                  <el-input v-model="orderForm.shippingDetail.zipcode" auto-complete="off" placeholder="根据仓码自动匹配，可修改" v-on:input="queryFbaByAdressOrZipcode"></el-input>
                </el-form-item>
              </div>
            </div>
        </el-form>
      </div>
      <div class="plate-content">
        <div class="plate-content__title">
          <span class="title">装箱单信息</span>
          <el-checkbox style="margin-left:20px;" v-model="orderForm.generalTrade" :checked="true">一般贸易</el-checkbox>
          <el-checkbox style="margin-left:20px;" v-model="orderForm.purchaseInsurance" >是否购买保险</el-checkbox>
        </div>
        <el-form :model="orderForm.packingList" size="small" :rules="orderFormRule3" ref="orderForm3" class="new-order__form" :label-width="formLabelWidth">
          <div class="inline-flex">
            <div>
              <el-form-item label="货物类型" prop="goodsType">
                <el-select v-model="orderForm.packingList.goodsType">
                  <el-option label="普货" value="COMMON"></el-option>
                  <el-option label="带电" value="CHARGED"></el-option>
                  <el-option label="带磁" value="MAGNETIC"></el-option>
                  <el-option label="带电带磁" value="CHARGED_MAGNETIC"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="总体积(cbm)" v-show="!formData.usMeasure">
                <el-input v-model="allTiji" auto-complete="off" placeholder="总体积" disabled></el-input>
                <el-tooltip class="item" effect="dark" content="仅供参考" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="货物箱数" prop="totalCarton">
                <el-input v-model="orderForm.packingList.totalCarton" :disabled="true" auto-complete="off" type="number" placeholder="货物箱数"></el-input>
              </el-form-item>
              <el-form-item label="总重量(kg)" v-show="!formData.usMeasure">
                <el-input v-model="allWeight" auto-complete="off" placeholder="总重量" disabled></el-input>
                <el-tooltip class="item" effect="dark" content="仅供参考" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </el-form-item>
            </div>
          </div>
          <div class="carton-table__content">
            <div class="toggle-wrapper">
              <el-button type="text" size="mini" @click="handleAddGuige" v-show="editCarton">添加箱子信息</el-button>
              <el-button type="text" size="mini" @click="expandCartons = !expandCartons">
                <span v-if="!expandCartons">展开箱子信息</span>
                <span v-else>收起箱子信息</span>
              </el-button>
            </div>
            <el-table :data="guigeArr" border class="m-b-20" v-if="expandCartons">
              <el-table-column prop="number" label="箱数" width="50"></el-table-column>
              <el-table-column prop="customerCartonNumber" label="客户箱号"></el-table-column>
              <el-table-column prop="cartonNumber" label="系统箱号" width="220"></el-table-column>
              <el-table-column label="预报" align="center">
                <el-table-column prop="long" label="长(cm)"></el-table-column>
                <el-table-column prop="width" label="宽(cm)"></el-table-column>
                <el-table-column prop="height" label="高(cm)"></el-table-column>
                <el-table-column prop="weight" label="毛重(kg)"></el-table-column>
              </el-table-column>
              <el-table-column label="实测" align="center">
                <el-table-column prop="actuallyLength" label="长(cm)"></el-table-column>
                <el-table-column prop="actuallyWidth" label="宽(cm)"></el-table-column>
                <el-table-column prop="actuallyHeight" label="高(cm)"></el-table-column>
                <el-table-column prop="actuallyWeight" label="毛重(kg)"></el-table-column>
              </el-table-column>
              <el-table-column label="SKU" width="200">
                <template slot-scope="scope">
                  <p v-for="(d,i) in scope.row.skus" :key="i">{{d.sku}}</p>
                </template>
              </el-table-column>
              <el-table-column label="SKU数量">
                <template slot-scope="scope">
                  <p v-for="(d,i) in scope.row.skus" :key="i">{{d.number}}</p>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="250">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" @click="measureEditSkus(scope.$index)">添加/编辑SKU</el-button>
                  <el-button type="text" size="mini" v-show="(!scope.row.actuallyLength || !scope.row.cartonNumber) && editCarton" @click="handleEditGuige( scope.row, scope.$index)">编辑</el-button>
                  <el-button type="text" size="mini" v-show="(!scope.row.actuallyLength || !scope.row.cartonNumber) && editCarton" @click="handleDeleteGuige(scope.row, scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <!-- 这个表格没有任何实际意义，只是为了配合切换展开/收起箱子箱子信息时页面的提示字段 -->
            <el-table :data="emptyArray" border class="m-b-20" v-else empty-text="表格数据默认是收起状态，请点击上方按钮查看详情... ...">
              <el-table-column label="箱数" width="50"></el-table-column>
              <el-table-column label="客户箱号"></el-table-column>
              <el-table-column label="系统箱号" width="220"></el-table-column>
              <el-table-column label="预报" align="center">
                <el-table-column label="长(cm)"></el-table-column>
                <el-table-column label="宽(cm)"></el-table-column>
                <el-table-column label="高(cm)"></el-table-column>
                <el-table-column label="毛重(kg)"></el-table-column>
              </el-table-column>
              <el-table-column label="实测" align="center">
                <el-table-column label="长(cm)"></el-table-column>
                <el-table-column label="宽(cm)"></el-table-column>
                <el-table-column label="高(cm)"></el-table-column>
                <el-table-column label="毛重(kg)"></el-table-column>
              </el-table-column>
              <el-table-column label="SKU" width="200"> </el-table-column>
              <el-table-column label="SKU数量"> </el-table-column>
              <el-table-column label="操作"></el-table-column>
            </el-table>
          </div>
          
        </el-form>
      </div>
    </el-card>
    <div class="submit-buttons">
      <el-button @click="back">返 回</el-button>
      <el-button type="primary" @click="editOrderSubmit">确 定</el-button>
    </div>

    <!-- 地图 -->
    <!-- <sp-amap id="sp-amap" v-if="initialDataWarehouseAddress.length != 0" width="100%" :class="{isOpen: isOpen}" :markers="initialDataWarehouseAddress" :isOpen="isOpen" @get-map-form="getMapForm" @get-geocoder="getGeocoder"></sp-amap> -->

    <!-- 上门取件弹层 -->
    <el-dialog title="编辑地址" :visible.sync="addressFormVisible" width="500px" class="fullwidth-form__dialog">
      <el-form size="small" :model="addressForm" label-width="80px" label-position="left">
        <el-form-item label="联系人">
          <el-input v-model.lazy="orderForm.deliveryDetail.contractName" placeholder="联系人"></el-input>
        </el-form-item>
        <el-form-item label="电话">
          <el-input v-model.lazy="orderForm.deliveryDetail.phone" placeholder="电话"></el-input>
        </el-form-item>
        <el-form-item label="州/省">
          <el-select v-model="deliveryDetail.provinceId" @change="queryCityOfChina" filterable>
            <el-option v-for="(province,i) in initialDataProvinceChina" :key="i" :label="province.nameCn" :value="province.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="市">
          <el-select v-model="orderForm.deliveryDetail.city" filterable>
            <el-option v-for="(city,i) in initialDataCityChina" :key="i" :label="city.nameCn" :value="city.nameCn"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="详细地址">
          <el-input v-model.lazy="orderForm.deliveryDetail.addressFirst" placeholder="详细地址"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="saveAddressOfDeliver">保 存</el-button>
      </div>
    </el-dialog>

    <!-- 添加SKU -->
    <el-dialog class="sp-info-box" title="商品信息" :visible.sync="listTable" @close="skuEditClose" width="1000px">
      <div style="margin-bottom:10px; text-align: right;">
        <el-button size="small" @click="spHandleEdit">新增</el-button>
        <el-button size="small" @click="lishiTable = true">历史商品列表</el-button>
      </div>
      <el-table :data="spList" border style="width: 100%">
        <el-table-column prop="sku" label="SKU">
        </el-table-column>
        <el-table-column prop="zhName" label="中文品名"></el-table-column>
        <el-table-column prop="enName" label="英文品名"></el-table-column>
        <el-table-column prop="code" label="海关编码"></el-table-column>
        <el-table-column prop="money" label="申报价值"></el-table-column>
        <el-table-column label="数量">
          <template slot-scope="scope">
            <el-input size="small" v-model="scope.row.number"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="图片">
          <template slot-scope="scope">
            <img width="65" height="45" :src="scope.row.img">
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="spHandleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button type="text" @click="spHandleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="skuSaveSp">保 存</el-button>
      </div>
    </el-dialog>
    <!-- 添加箱子信息 -->
    <el-dialog :title="cartonDialogTitle" :visible.sync="addGuigeShow" width="400px" class="fullwidth-form__dialog">
      <el-form size="small" :model="addGuige" :rules="rulesAddGuige" ref="addGuige" label-width="80px" label-position="left" class="edit-address__from">
        <el-form-item v-show="false">
          <el-input v-model="addGuigeIndex" type="number" placeholder="index"></el-input>
        </el-form-item>
        <el-form-item label="长(CM)" class="must" prop="long" v-show="formData.usMeasure == false">
          <el-input v-model="addGuige.long" type="number" placeholder="长"></el-input>
        </el-form-item>
        <el-form-item label="宽(CM)" class="must" prop="width" v-show="formData.usMeasure == false">
          <el-input v-model="addGuige.width" type="number" placeholder="宽"></el-input>
        </el-form-item>
        <el-form-item label="高(CM)" class="must" prop="height" v-show="formData.usMeasure == false">
          <el-input v-model="addGuige.height" type="number" placeholder="高"></el-input>
        </el-form-item>
        <el-form-item label="毛重(KG)" class="must" prop="weight" v-show="formData.usMeasure == false">
          <el-input v-model="addGuige.weight" type="number" placeholder="毛重"></el-input>
        </el-form-item>
        <el-form-item label="箱数" class="must" prop="number">
          <el-input v-model="addGuige.number" type="number" placeholder="箱数"></el-input>
        </el-form-item>
        <el-form-item class="erro-info">
          <div class="erro-info-text" v-text="addGuigeErro"></div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click.native="handleSaveguige">保 存</el-button>
      </div>
    </el-dialog>

    <!-- 历史商品列表弹层 -->
    <el-dialog title="历史商品列表" :visible.sync="lishiTable" width="1000px">
      <el-form :inline="true" :model="conditions" class="demo-form-inline" size="small">
        <el-form-item>
          <el-input v-model="conditions.sku" placeholder="SKU/中文/英文品名" clearable style="width: 300px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="skuHistorySearch">搜索</el-button>
          <el-button type="success" @click="handleSaveSp">确 定</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="productData" border style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="sku" label="SKU">
        </el-table-column>
        <el-table-column prop="zhName" label="中文品名"></el-table-column>
        <el-table-column prop="enName" label="英文品名"></el-table-column>
        <el-table-column prop="code" label="海关编码"></el-table-column>
        <el-table-column prop="money" label="申报价值"></el-table-column>
        <el-table-column prop="img" label="图片">
          <template slot-scope="scope">
            <img width="65" height="45" :src="scope.row.img">
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next" :total="productHistoryList.total" :page-size="productHistoryList.pageSize" :current-page="productHistoryList.page" @current-change="currentPage" class="t-a-r m-t-20"></el-pagination>
    </el-dialog>
    <!-- 新增商品信息弹层 -->
    <el-dialog :title="editProductTitle" :visible.sync="addSPinfo" width="500px" class="fullwidth-form__dialog neworder-editsku__dialog">
      <el-form size="small" label-width="120px" label-position="left" :model="tmpProduct" :rules="rulesTmpProduct" ref="tmpProduct" class="add-product__form">
        <el-form-item label="SKU" prop="sku">
          <el-input placeholder="id" v-show="false" v-model="tmpProduct.id"></el-input>
          <el-input placeholder="SKU" v-model="tmpProduct.sku"></el-input>
        </el-form-item>
        <el-form-item label="中文品名" prop="zhName">
          <el-input placeholder="中文品名" v-model="tmpProduct.zhName"></el-input>
        </el-form-item>
        <el-form-item label="海关编码" prop="code">
          <el-input placeholder="海关编码" v-model="tmpProduct.code"></el-input>
        </el-form-item>
        <el-form-item label="英文品名" prop="enName">
          <el-input placeholder="英文品名" v-model="tmpProduct.enName"></el-input>
        </el-form-item>
        <el-form-item label="单个净重" prop="weight">
          <el-input placeholder="单个净重" type="number" v-model="tmpProduct.weight"></el-input>
        </el-form-item>
        <el-form-item label="申报价值" prop="money">
          <div class="inline-flex">
            <el-select v-model="tmpProduct.currency" placeholder="请选择币种" size="small">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-input placeholder="申报价值" type="number" v-model="tmpProduct.money"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="商品图片" :label-width="formLabelWidth" prop="img">
          <el-upload action="#" :file-list="imgFile" list-type="picture-card" :limit="1" :on-change="imgChange" :auto-upload="false">
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible" append-to-body>
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="warning" size="small" v-show="nextAddProductButton" @click="handleAddSpContinue">继续添加</el-button>
        <el-button type="primary" size="small" @click="handleAddSp">完 成</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import formatDate from '../../../utils/formatDate.js'

function clone(obj) {
  if (!obj || typeof obj != "object") return obj;
  let _newObj = new Object();
  for (let key in obj) {
    _newObj[key] = clone(obj[key]);
  }
  return _newObj;
}

export default {
  components: {},
  data() {
    var checkNumber = (rule, value, callback) => {
      if (!this.formData.usMeasure) {
        if (!/^\d+.?\d{0,4}$/.test(value) || value < 0) {
          callback(new Error("请输入大于0的整数或小数,小数最大精确4位"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    var checkInteger = (rule, value, callback) => {
      if (!/^\d+$/.test(value) || value <= 0) {
        callback(new Error("请输入大于0的整数"));
      } else {
        callback();
      }
    };
    var checkFormHeadDate = (rule, value, callback) => {
      if (
        this.orderForm.deliveryDetail.deliveryType == "DELIVERY" ||
        this.orderForm.deliveryDetail.deliveryType == "PICK_UP_FROM_CUSTOMER"
      ) {
        if (!value || value == "") {
          callback(new Error("日期不能为空，请选择日期"));
        } else {
          //地址校验
          if (
            this.orderForm.deliveryDetail.addressFirst == "" ||
            this.orderForm.deliveryDetail.city == "" ||
            this.orderForm.deliveryDetail.contractName == "" ||
            this.orderForm.deliveryDetail.phone == "" ||
            this.orderForm.deliveryDetail.province == ""
          ) {
            callback(new Error("请点击'编辑地址'按钮补全地址信息"));
          } else {
            callback();
          }
        }
      } else {
        callback();
      }
    };
    var checkFormHeadText = (rule, value, callback) => {
      if (this.orderForm.deliveryDetail.deliveryType == "DELIVERY_BY_EXPRESS") {
        if (!value || value == "") {
          callback(new Error("快递信息不能为空"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    var checkFormBodyTextorderNumber = (rule, value, callback) => {
      if (!this.fbaChecked) {
        if (this.orderForm.customerRefnumber.customerOrderNumber == "")
          callback(new Error("客户单号必填"));
        callback();
      } else {
        callback();
      }
    };
    var checkFormBodyTextaddressFirst = (rule, value, callback) => {
      if (!this.fbaChecked) {
        if (this.orderForm.shippingDetail.addressFirst == "")
          callback(new Error("详细地址1必填"));
        callback();
      } else {
        callback();
      }
    };

    var checkFormBodyTextcity = (rule, value, callback) => {
      if (!this.fbaChecked) {
        if (this.orderForm.shippingDetail.city == "")
          callback(new Error("城市必选"));
        callback();
      } else {
        callback();
      }
    };
    var checkFormBodyTextcontractName = (rule, value, callback) => {
      if (!this.fbaChecked) {
        if (this.orderForm.shippingDetail.contractName == "")
          callback(new Error("联系人必填"));
        callback();
      } else {
        callback();
      }
    };
    var checkFormBodyText = (rule, value, callback) => {
      if (!this.fbaChecked) {
        if (this.orderForm.shippingDetail.country == "")
          callback(new Error("国家必选"));
        callback();
      } else {
        callback();
      }
    };
    var checkFormBodyTextcountry = (rule, value, callback) => {
      if (!this.fbaChecked) {
        if (this.orderForm.shippingDetail.country == "")
          callback(new Error("国家必选"));
        callback();
      } else {
        callback();
      }
    };
    var checkFormBodyTextphone = (rule, value, callback) => {
      if (!this.fbaChecked) {
        if (this.orderForm.shippingDetail.phone == "")
          callback(new Error("联系电话"));
        callback();
      } else {
        callback();
      }
    };
    var checkFormBodyTextprovince = (rule, value, callback) => {
      if (!this.fbaChecked) {
        if (this.orderForm.shippingDetail.province == "")
          callback(new Error("省份&州必选"));
        callback();
      } else {
        callback();
      }
    };

    var checkFormBottomTotalCarton = (rule, value, callback) => {
      if (!value || !parseInt(value) || isNaN(value) || parseInt(value) <= 0) {
        callback(new Error("货物箱数必须为大于0的整数"));
      } else {
        callback();
      }
    };
    return {
      conditions: {
        sku: "",
        zhName: "",
        enName: ""
      },
      imgFile: [],
      //高德地图
      expandCartons: false,
      emptyArray: [],
      isInit: true,
      isOpen: false,
      mapObj: {},
      userCarry: [
        {
          title: "",
          address: "",
          name: "",
          phone: "",
          distance: ""
        }
      ],
      mapAddressFormVisible: false,
      fbaChecked: true,
      formData: {
        usMeasure: false
      },

      orderForm: {
        orgOwner: "",
        orgOp: "",
        warehousCode: "",
        productId: "",
        remark: "",
        customerRefnumber: { customerOrderNumber: "", fbaNumber: "" },
        deliveryDetail: {
          deliveryType: "PICK_UP_FROM_CUSTOMER",
          warehouseCode: "",
          appointmentAt: formatDate(new Date()),
          expressCompany: "",
          expressNumber: "",
          contractName: "",
          phone: "",
          country: "",
          province: "",
          city: "",
          addressFirst: ""
        },
        shippingDetail: {
          contractName: "",
          phone: "",
          country: "",
          countryId: "",
          province: "",
          city: "",
          zipcode: "",
          addressFirst: "",
          addressSecond: "",
          fbaWarehouseCode: "",
          companyName: ""
        },
        packingList: {
          goodsType: "",
          totalCarton: "",
          cartonDetails: []
        },
        generalTrade: true,
        purchaseInsurance: false,
        amazonReferenceId: ""
      },
      editOrderData: {},
      orderStatus: "",
      shippingDetail: {
        countryId: "",
        provinceId: "",
        cityId: ""
      },
      deliveryDetail: {
        provinceId: ""
      },
      productData: [],
      tmpProduct: {
        id: "",
        currency: "RMB",
        sku: "",
        weight: "",
        zhName: "",
        enName: "",
        code: "",
        money: "",
        img: ""
      },

      orderFormRule: {
        appointmentAt: [
          {
            validator: checkFormHeadDate,
            trigger: "change"
          }
        ],
        expressCompany: [
          {
            validator: checkFormHeadText,
            trigger: "blur"
          }
        ],
        expressNumber: [
          {
            validator: checkFormHeadText,
            trigger: "blur"
          }
        ],
        customerOrderNumber: [
          {
            required: true,
            message: "请填写快递单号",
            trigger: "blur"
          }
        ]
      },
      orderFormRule3: {
        goodsType: [
          {
            required: true,
            message: "请选择货物类型",
            trigger: "change"
          }
        ],
        totalCarton: [
          {
            validator: checkFormBottomTotalCarton,
            trigger: "blur"
          }
        ]
      },
      orderFormRule2: {
        customerOrderNumber: [
          {
            validator: checkFormBodyTextorderNumber,
            trigger: "change"
          }
        ],
        shippingPhone: [
          {
            validator: checkFormBodyTextphone,
            trigger: "change"
          }
        ],
        shippingProvince: [
          {
            validator: checkFormBodyTextprovince,
            trigger: "change"
          }
        ],
        zipcode: [{ required: true, message: "请输入邮编", trigger: "blur" }],
        shippingContractName: [
          {
            validator: checkFormBodyTextcontractName,
            trigger: "change"
          }
        ],
        shippingCountry: [
          {
            validator: checkFormBodyTextcountry,
            trigger: "change"
          }
        ],
        shippingCity: [
          {
            validator: checkFormBodyTextcity,
            trigger: "change"
          }
        ],
        shippingAddressFirst: [
          {
            validator: checkFormBodyTextaddressFirst,
            trigger: "change"
          }
        ]
      },
      rulesTmpProduct: {
        sku: [
          {
            required: true,
            message: "请输入SKU",
            trigger: "blur"
          }
        ],
        zhName: [
          {
            required: true,
            message: "请输入中文品名",
            trigger: "blur"
          }
        ],
        code: [
          {
            required: true,
            message: "请输入海关编码",
            trigger: "blur"
          }
        ],
        enName: [
          {
            required: true,
            message: "请输入英文品名",
            trigger: "blur"
          }
        ],
        weight: [
          {
            required: true,
            message: "请输入重量",
            trigger: "blur"
          }
        ],
        money: [
          {
            required: true,
            message: "请输入申报金额",
            trigger: "blur"
          }
        ]
      },
      productHistoryList: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      productForm: {
        test: "",
        guigeRadio: "2",
        select: "shanghai",
        boxNumber: 0
      },

      addressForm: {
        address: "广东省深圳市南山区学府路南山智园B11栋14楼(Daniel)",
        name: "blry",
        phone: "18682152960"
      },
      addressFormVisible: false,
      dialogFormVisible: false,
      formLabelWidth: "120px",
      options: [
        {
          value: "RMB",
          label: "人民币"
        },
        {
          value: "HKD",
          label: "港币"
        },
        {
          value: "GBP",
          label: "英镑"
        },
        {
          value: "USD",
          label: "美元"
        },
        {
          value: "JPY",
          label: "日元"
        },
        {
          value: "EUR",
          label: "欧元"
        }
      ],
      value: "",
      guige: {
        long: "",
        width: "",
        height: "",
        weight: ""
      },
      guigeArr: [],
      addGuige: {
        number: "",
        long: "",
        width: "",
        height: "",
        weight: ""
      },
      addGuigeErro: "",
      addGuigeShow: false,
      listTable: false, //添加sku
      addSPinfo: false,
      lishiTable: false,
      spList: [], //sku列表
      spListIndex: "",
      spListIndexData: "",
      standardSkus: [], //每箱同sku
      lishiList: [
        {
          sku: "HF001",
          zhName: "黑色签字笔",
          enName: "pen",
          enName: "pen",
          code: "547896542",
          money: "￥5.00",
          img:
            "https://y.gtimg.cn/music/photo_new/T001R300x300M000002J4UUk29y8BY.jpg?max_age=2592000"
        }
      ],
      dialogImageUrl: "", //上传图片
      dialogVisible: false,
      initialDataFbaAddress: [],
      initialDataCountry: [],
      initialDataProvince: [],
      initialDataCity: [],
      initialDataProvinceChina: [],
      initialDataCityChina: [],
      initialDataWarehouseAddress: [],
      currentWarehouseAddress: "",
      addImg: "",
      cartonDialogTitle: "添加货箱信息",
      addGuigeIndex: "",
      originItemNum: 0,
      rulesAddGuige: {
        number: [
          {
            validator: checkInteger,
            trigger: "blur"
          }
        ],
        long: [
          {
            validator: checkNumber,
            trigger: "blur"
          }
        ],
        width: [
          {
            validator: checkNumber,
            trigger: "blur"
          }
        ],
        height: [
          {
            validator: checkNumber,
            trigger: "blur"
          }
        ],
        weight: [
          {
            validator: checkNumber,
            trigger: "blur"
          }
        ]
      },
      appointmentAtOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            }
          },
          {
            text: "明天",
            onClick(picker) {
              let _tomorrow = new Date(
                new Date(
                  new Date().getTime() + 3600 * 1000 * 24
                ).toLocaleDateString()
              );
              picker.$emit("pick", _tomorrow);
            }
          },
          {
            text: "后天",
            onClick(picker) {
              let _afterTomorrow = new Date(
                new Date(
                  new Date().getTime() + 3600 * 1000 * 24 * 2
                ).toLocaleDateString()
              );
              picker.$emit("pick", _afterTomorrow);
            }
          }
        ],
        disabledDate(time) {
          return time < new Date(new Date().toLocaleDateString()).getTime();
        }
      },
      editProductTitle: "新增商品信息",
      nextAddProductButton: true,
      clone(obj) {
        if (!obj || typeof obj != "object") return obj;
        let _newObj = new Object();
        for (let key in obj) {
          _newObj[key] = clone(obj[key]);
        }
        return _newObj;
      },
      //edit order
      editOrderId: "",
      editCarton: true,
      channelData: [],
      flag: false,
      warehouseData: [],
      warehouseId: "",
      default_warehousCode: "",  // 根据showOrderDetailById方法查询到的warehousCode
      warehouse: []
    };
  },

  computed: {
    //总体积
    allTiji: function() {
      if (this.guigeArr.length > 0) {
        let num = 0;
        this.guigeArr.forEach((d, i) => {
          if (d.number && d.long && d.width && d.height) {
            num +=
              (parseInt(d.number) *
                parseInt(d.long) *
                parseInt(d.width) *
                parseInt(d.height)) /
              1000000;
          }
        });
        return num.toFixed(4);
      } else {
        return 0;
      }
    },
    //总重量
    allWeight: function() {
      if (this.guigeArr.length == 0) return 0;
      let num = 0;
      this.guigeArr.forEach((d, i) => {
        if (d.number && d.weight) {
          num += parseInt(d.number) * parseInt(d.weight);
        }
      });
      return num.toFixed(4);
    }
  },
  created() {
    // init data
    this.editOrderId = this.$route.query.orderId;
    this.editCarton = this.$route.query.editCarton;
    var _this = this;

    _this.queryProvinceOfChina();

    _this.findAllChannle();
    this.showOrderDetailById(this.editOrderId);
    // 查询fba地址
    setTimeout(() => {
      _this.queryWarehouseData();
    }, 800);
  },
  methods: {
    findAllChannle() {
      let _this = this;
      this.$request1({
        method: 'GET',
        url: '/system/channel/all'
      })
        .then(response => {
          this.channelData = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    changeGuigeRadio() {
      this.guige = {
        long: "",
        width: "",
        height: "",
        weight: ""
      };
      this.guigeArr = [];
    },
    //改变产品
    changeChannel() {
      this.queryFbaAddress();
      this.queryCountrys();
    },
    //查询订单信息
    showOrderDetailById(editOrderId) {
      let _this = this;
      this.$request1
        .get(
          '/order/' + editOrderId + '/edit/query',
          {
            withCredentials: true
          }
        )
        .then(res => {
          if (res.data.success) {
            this.default_warehousCode = res.data.data.warehousCode  // 获取该订单的仓库
            this.productForm.guigeRadio = "2";
            let resData = res.data.data;
            this.orderStatus = resData.status;
            let querydeliveryDetail = resData.deliveryDetail;
            let deliAddress = querydeliveryDetail.address;

            //发件人地址明细
            let queryShippingDetail = resData.shippingDetail;
            let queryLocalLanguageShippingDetail = resData.localLanguageDetail;
            this.orderForm = {};
            this.orderForm = {
              generalTrade: resData.generalTrade,
              purchaseInsurance: resData.purchaseInsurance,
              amazonReferenceId: resData.amazonReferenceId,
              orgOwner: resData.orgOwner,
              orgOp: resData.orgOp,
              warehousCode: resData.warehousCode,
              productId: resData.product,
              // product: resData.product,
              remark: resData.remark,
              customerRefnumber: resData.customerRefnumber
                ? resData.customerRefnumber
                : { customerOrderNumber: "", fbaNumber: "" },
              deliveryDetail: {
                deliveryType: querydeliveryDetail.deliveryType,
                warehouseCode: querydeliveryDetail.warehouseCode,
                appointmentAt: new Date(querydeliveryDetail.appointmentAt),

                expressCompany: querydeliveryDetail.shipment.provider,
                expressNumber: querydeliveryDetail.shipment.trackingNumber,

                contractName: querydeliveryDetail.contractDatail.name,
                phone: querydeliveryDetail.contractDatail.phone,

                country: deliAddress.country,
                province: deliAddress.province,
                provinceId: deliAddress.province,
                city: deliAddress.city,
                addressFirst: querydeliveryDetail.address.address
              },
              shippingDetail: {
                contractName: queryShippingDetail.contractDatail.name,
                phone: queryShippingDetail.contractDatail.phone,
                country: queryShippingDetail.address.country,
                countryId: queryShippingDetail.address.country,
                province: queryShippingDetail.address.province,
                city: queryShippingDetail.address.city,
                zipcode: queryShippingDetail.address.zipcode,
                addressFirst: queryShippingDetail.address.address,
                addressSecond: queryShippingDetail.address.address2,
                fbaWarehouseCode: queryShippingDetail.address.fbaWarehouseCode,
                companyName: queryShippingDetail.address.companyName
              },
              packingList: resData.packingList
            };
            // if (queryShippingDetail.address.fbaWarehouseCode) {
            //   this.fbaChecked = true;
            // } else {
            //   this.fbaChecked = false;
            // }
            this.guigeArr = [];
            //箱明细
            resData.packingList.cartonDetails.forEach((d, i) => {
              let cartonSkus = [];
              d.items.forEach((s, k) => {
                cartonSkus.push({
                  sku: s.sku,
                  number: s.qty
                });
              });
              this.guigeArr.push({
                number: 1,
                customerCartonNumber: d.customerCartonNumber,
                cartonNumber: d.cartonNumber,
                long: d.length,
                width: d.width,
                height: d.height,
                weight: d.weight,
                actuallyLength: d.actuallyLength,
                actuallyWidth: d.actuallyWidth,
                actuallyHeight: d.actuallyHeight,
                actuallyWeight: d.actuallyWeight,
                skus: cartonSkus
              });
            });
            this.queryFbaAddress();
            this.queryCountrys();
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    back() {
      this.$router.go(-1);
    },
    //高德地图保存地址
    handleSmenSaveMap() {
      this.mapAddressFormVisible = false;
      this.userCarry[0].title = this.mapObj.title;
      this.userCarry[0].address = this.mapObj.address;
      this.userCarry[0].name = this.mapObj.name;
      this.userCarry[0].phone = this.mapObj.phone;
      this.userCarry[0].distance = this.mapObj.distance;
    },
    //点击仓库
    getMapForm(val) {
      this.mapObj = val;
      this.currentWarehouseAddress = val;
      if (
        this.orderForm.deliveryDetail.deliveryType == "DELIVERY" ||
        this.orderForm.deliveryDetail.deliveryType == "DELIVERY_BY_EXPRESS"
      ) {
        this.orderForm.deliveryDetail.warehouseCode = val.id;
        this.orderForm.deliveryDetail.contractName = val.receiptPersonName;
        this.orderForm.deliveryDetail.phone = val.receiptPersonPhone;
        this.orderForm.deliveryDetail.country =
          val.warehouseAddress.countryCode;
        this.orderForm.deliveryDetail.province = val.warehouseAddress.province;
        this.orderForm.deliveryDetail.city = val.warehouseAddress.city;
        this.orderForm.deliveryDetail.addressFirst =
          val.warehouseAddress.address;
      } else {
        this.orderForm.deliveryDetail.warehouseCode = val.id;
      }

      if (this.isInit) {
        this.userCarry[0].title = val.name;
        this.userCarry[0].address = val.warehouseAddress.address;
        this.userCarry[0].name = val.receiptPersonName;
        this.userCarry[0].phone = val.phone;
        this.userCarry[0].distance = val.distance;
        this.isInit = false;
      }
    },
    //获取经纬度：
    getGeocoder(val) {
      console.log("获取经纬度： " + JSON.stringify(val));
    },
    //地图编辑地址
    handleMapEdit(index, row) {
      var self = this;
      this.mapAddressFormVisible = true;
      if (!this.isOpen) {
        clearTimeout(timer);
        let timer = setTimeout(function() {
          self.$refs.spAmap.appendChild(document.getElementById("sp-amap"));
          self.isOpen = true;
        }, 50);
      }
    },
    //模糊查找fba仓
    queryFbaByAdressOrZipcode() {
      let _this = this;
      _this.$request1
        .get(
          '/warehouse-address/query-fba',
          {
            params: {
              adress: _this.orderForm.shippingDetail.addressFirst,
              zipcode: _this.orderForm.shippingDetail.zipcode
            },
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          if (response.status == 200 && response.data.success) {
            _this.orderForm.shippingDetail.fbaWarehouseCode = "";
            _this.initialDataFbaAddress = response.data.data;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    //编辑地址
    handleEdit(index, row) {
      this.addressFormVisible = true;
    },
    //------------------箱子信息-----------------------------------------//
    //保存箱信息
    handleSaveguige() {
      let _this = this;
      let _valid = false;
      _this.$refs["addGuige"].validate(valid => {
        if (!valid) {
          _valid = false;
        } else {
          _valid = true;
        }
      });
      if (!_valid) {
        return false;
      }
      for (let key in _this.addGuige) {
        let item = _this.addGuige[key];
        if (
          !_this.formData.usMeasure &&
          (!item || isNaN(item) || parseFloat(item) <= 0)
        ) {
          //SPFunc.spAlert(_this, "必须大于0");
          //return;
        }
      }
      this.addGuigeShow = false;
      if (
        // (this.addGuigeIndex != "" &&
        // this.addGuigeIndex !== undefined &&
        // !isNaN(this.addGuigeIndex))
        this.addGuigeIndex ||
        this.addGuigeIndex === 0
      ) {
        this.guigeArr.splice(this.addGuigeIndex, 1, {
          number: _this.addGuige.number,
          cartonNumber: _this.addGuige.cartonNumber,
          long: _this.addGuige.long,
          width: _this.addGuige.width,
          height: _this.addGuige.height,
          weight: _this.addGuige.weight,

          // actuallyLength: _this.addGuige.long,
          // actuallyWidth: _this.addGuige.width,
          // actuallyHeight: _this.addGuige.height,
          // actuallyWeight: _this.addGuige.weight,
          skus: _this.addGuige.skus
        });
      } else {
        this.guigeArr.push({
          number: _this.addGuige.number,
          long: _this.addGuige.long,
          width: _this.addGuige.width,
          height: _this.addGuige.height,
          weight: _this.addGuige.weight

          // actuallyLength: _this.addGuige.long,
          // actuallyWidth: _this.addGuige.width,
          // actuallyHeight: _this.addGuige.height,
          // actuallyWeight: _this.addGuige.weight
        });
      }
      this.orderForm.packingList.totalCarton =
        Number(this.orderForm.packingList.totalCarton) +
        Number(this.addGuige.number) -
        this.originItemNum;

      this.addGuigeIndex = undefined;
      this.addGuige = {
        number: "",
        long: "",
        width: "",
        height: "",
        weight: ""
      };
    },
    //编辑箱子信息
    handleEditGuige(item, index) {
      this.cartonDialogTitle = "编辑货箱信息";
      this.addGuige = item;
      this.addGuigeIndex = index;
      this.addGuigeShow = true;
      this.originItemNum = item.number;
    },
    //新增
    handleAddGuige() {
      this.addGuigeShow = true;
      this.addGuige = {
        number: "",
        long: "",
        width: "",
        height: "",
        weight: ""
      };
      this.cartonDialogTitle = "添加货箱信息";
    },
    //查询和编辑sku
    measureEditSkus(index) {
      //箱子规格不同编辑sku
      let _this = this;
      if (_this.guigeArr[index]) {
        if (_this.guigeArr[index].skus) {
          //查询sku的信息
          let skus = [];
          _this.guigeArr[index].skus.forEach((s, i) => {
            skus.push(s.sku);
          });
          let cartonSkuMaps = [];
          _this.spList = [];
          _this.$request1
            .get(
              '/center/query/skus',
              {
                params: {
                  skus: skus,
                  orgOwner: _this.orderForm.orgOwner
                },
                withCredentials: true,
                headers: {
                  "content-type": "application/json"
                }
              }
            )
            .then(res => {
              if (res.data.success) {
                if (res.data.data.length > 0) {
                  res.data.data.forEach((sku, i) => {
                    cartonSkuMaps[sku.sku] = sku;
                  });
                }
                _this.guigeArr[index].skus.forEach((s, j) => {
                  let cartonSku = cartonSkuMaps[s.sku];
                  _this.spList.push({
                    id: cartonSku ? cartonSku.id : "",
                    weight: cartonSku ? cartonSku.weight : "",
                    currency: cartonSku ? cartonSku.currency : "",
                    sku: s.sku,
                    zhName: cartonSku ? cartonSku.zhName : "",
                    enName: cartonSku ? cartonSku.enName : "",
                    code: cartonSku ? cartonSku.code : "",
                    money: cartonSku ? cartonSku.money : "",
                    img: cartonSku ? cartonSku.img : "",
                    number: s.number
                  });
                });
              } else {
                console.log(res.data.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          _this.guigeArr[index].skus = new Array();
          _this.spList = JSON.parse(JSON.stringify(_this.guigeArr[index].skus));
        }
        _this.spListIndex = index;
        _this.spListIndexData = _this.guigeArr[index];
        _this.listTable = true;
      }
    },
    //删除箱信息
    handleDeleteGuige(item, index) {
      this.guigeArr.splice(index, 1);
      this.orderForm.packingList.totalCarton =
        this.orderForm.packingList.totalCarton - item.number;
    },
    //-------------------商品信息------------------
    //新增/编辑商品信息
    spHandleEdit(index, row) {
      let _this = this;
      _this.addSPinfo = true;
      _this.imgFile = [];
      if (row) {
        _this.editProductTitle = "编辑商品信息";
        _this.nextAddProductButton = false;
        _this.tmpProduct = row;
        let file = new Object();
        file.url = row.img;
        _this.imgFile.push(file);
      } else {
        _this.editProductTitle = "新增商品信息";
        _this.nextAddProductButton = true;
        // _this.tmpProduct = new Object();
        // _this.tmpProduct.id = "";
        // _this.tmpProduct.currency = "RMB";
        // _this.tmpProduct.sku = "";
        // _this.tmpProduct.weight = "";
        // _this.tmpProduct.zhName = "";
        // _this.tmpProduct.enName = "";
        // _this.tmpProduct.code = "";
        // _this.tmpProduct.money = "";
        // _this.tmpProduct.img = "";
        // _this.addImg = "";
        _this.emptyTmpProductForm();
      }
    },
    //删除商品信息
    spHandleDelete(index, row) {
      this.spList.splice(index, 1);
    },
    showSkuHistory() {
      this.loadProducts();
      this.lishiTable = true;
    },
    //历史商品列表选中
    handleSelectionChange(val) {
      this.spListSelection = val;
    },
    //历史商品列表保存
    handleSaveSp() {
      this.lishiTable = false;
      this.spListSelection.forEach((d, i) => {
        let _d = this.clone(d);
        this.spList.push(_d);
      });
    },

    currentPage(page) {
      this.productHistoryList.page = page;
      let sku = this.conditions.sku;
      this.loadProducts(sku);
    },
    skuEditClose() {
      let _this = this;
      let _removeIndex = new Array();
      if (_this.spList) {
        for (let i = 0; i < _this.spList.length; i++) {
          if (!_this.spList[i].number || _this.spList[i].number <= 0) {
            _this.spList.splice(i, 1);
            i--;
          }
        }
      }
    },
    //sku数据保存
    skuSaveSp() {
      let _this = this;
      let _isFailed = false;
      _this.spList.forEach((data, index) => {
        if (!data.number || data.number <= 0 || isNaN(data.number)) {
          _isFailed = true;
        }
      });
      if (_isFailed) {
        _this.$message.error("SKU数量必须为大于0的数字");
      } else {
        _this.listTable = false;
      }
      if (_this.spListIndexData && _this.spListIndexData != "") {
        _this.spListIndexData.skus = JSON.parse(JSON.stringify(_this.spList));
        _this.$set(_this.guigeArr, _this.spListIndex, _this.spListIndexData);
      }
    },
    //历史搜索
    skuHistorySearch() {
      this.productHistoryList.page = 1;
      this.loadProducts(this.conditions.sku);
    },
    loadProducts(sku) {
      //初始化sku
      let _this = this;
      _this.$request1
        .get(
          '/center/productList',
          {
            params: {
              orgOwner: _this.orderForm.orgOwner,
              page: _this.productHistoryList.page,
              pageSize: _this.productHistoryList.pageSize,
              sku: sku
            },
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(res => {
          if (res.data && res.data.products.length > 0) {
            _this.productData = res.data.products;
            _this.productHistoryList.total = res.data.total;
          } else {
            _this.productData = null;
            _this.productHistoryList.total = 0;
            _this.$message.error(res.data.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    imgChange(file, fileList) {
      this.addImg = file.raw;
    },
    //新增/编辑商品信息保存
    handleAddSp(index, row) {
      this.addProduct(true);
    },
    handleAddSpContinue() {
      this.addProduct(false);
    },
    getFormData(form, pic) {
      let _this = this;
      var formData = new FormData();
      for (var key in form) {
        formData.append(key, form[key]);
      }
      formData.append("pic", pic);
      formData.append("orgOwner", this.orderForm.orgOwner);
      return formData;
    },
    addProduct(closeEdit) {
      let _this = this;
      let _valid = true;
      _this.$refs["tmpProduct"].validate(valid => {
        if (!valid) {
          _valid = false;
        }
      });
      if (!_valid) {
        return false;
      }

      let pattenNum = /^[0-9]+\.?[0-9]*$/
      if (!pattenNum.test(_this.tmpProduct.money)) {
        this.$message.error('请输入正确的申报价值')
        return
      }
      if (!pattenNum.test(_this.tmpProduct.weight)) {
        this.$message.error('请输入正确的单个净重')
        return
      }

      let form = _this.tmpProduct;
      let formData = _this.getFormData(form, _this.addImg);

      _this.$request1
        .post(
          '/center/product/addProduct',
          formData,
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          if (res.status == 413) {
            _this.$notify.error({
              title: "创建失败,异常提示:",
              message:
                "文件超过规定大小，限制最大不超过10MB，请精简其中图片内容后重新上传。"
            });
          } else if (res.data.success) {
            if (res.data.data && res.data.data.length > 0) {
              //添加到历史数据并添加到列表
              if (!_this.tmpProduct || !_this.tmpProduct.id) {
                _this.spList.push(res.data.data[0]);
                _this.productData.push(res.data.data[0]);
                _this.productHistoryList.total += 1;
              }
            }
            if (closeEdit) {
              // 为true，完成并关闭弹层；为false，继续添加
              _this.addSPinfo = false;
            }
            _this.emptyTmpProductForm();
            _this.$refs["tmpProduct"].resetFields();
            _this.$notify({
              title: "成功",
              message: "商品信息添加成功",
              type: "success"
            });
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.status === 413) {
            _this.$notify.error({
              title: "请求失败,异常提示:",
              message:
                "文件超过规定大小，限制最大不超过10MB，请精简其中图片内容后重新上传。"
            });
          } else {
            _this.$notify.error({
              title: "请求失败,异常提示:",
              message: error.response.statusText,
              duration: 0
            });
          }
        });
    },
    // 清空新增商品表单
    emptyTmpProductForm() {
      this.tmpProduct = {
        id: "",
        currency: "RMB",
        sku: "",
        weight: "",
        zhName: "",
        enName: "",
        code: "",
        money: "",
        img: ""
      };
      this.addImg = "";
      this.imgFile = [];
    },
    // 关闭新增商铺弹层
    handleClose() {
      this.addSPinfo = false;
      this.emptyTmpProductForm();
      this.$refs["tmpProduct"].resetFields();
    },
    // 图片本地上传预览
    previewFiles() {
      var preview = document.querySelector(".file-content img");
      var file = document.querySelector("input[type=file]").files[0];
      var reader = new FileReader();

      reader.addEventListener(
        "load",
        function() {
          if (/\.(jpe?g|png|gif)$/i.test(file.name)) {
            preview.src = reader.result;
            preview.style.width = "50px";
            preview.style.height = "50px";
            preview.style.display = "block";
          } else {
            SPFunc.spAlert(
              _this,
              "请上传合法的图片类型，如:jpg, jpeg, png, gif"
            );
          }
        },
        false
      );

      if (file) {
        reader.readAsDataURL(file);
      }
    },
    editCartonSkus() {
      let _this = this;
      _this.listTable = true;
      _this.spList = _this.standardSkus;
      _this.spListIndexData = null;
      _this.spListIndex = -1;
    },
    saveAddressOfDeliver() {
      let _this = this;
      _this.addressFormVisible = false;
      _this.initialDataProvinceChina.forEach((d, i) => {
        if (_this.deliveryDetail.provinceId == d.id) {
          _this.orderForm.deliveryDetail.province = d.nameCn;
        }
      });
    },
    changedeliveryType(v) {
      let _this = this;
      if (v == "DELIVERY" || v == "DELIVERY_BY_EXPRESS") {
        //送货到仓库
        _this.orderForm.warehousCode = _this.currentWarehouseAddress.id;
        _this.orderForm.deliveryDetail.warehouseCode =
          _this.currentWarehouseAddress.id;
        _this.orderForm.deliveryDetail.contractName =
          _this.currentWarehouseAddress.receiptPersonName;
        _this.orderForm.deliveryDetail.phone =
          _this.currentWarehouseAddress.receiptPersonPhone;
        _this.orderForm.deliveryDetail.country =
          _this.currentWarehouseAddress.warehouseAddress.countryCode;
        _this.orderForm.deliveryDetail.province =
          _this.currentWarehouseAddress.warehouseAddress.province;
        _this.orderForm.deliveryDetail.city =
          _this.currentWarehouseAddress.warehouseAddress.city;
        _this.orderForm.deliveryDetail.addressFirst =
          _this.currentWarehouseAddress.warehouseAddress.address;
      } else if (v == "PICK_UP_FROM_CUSTOMER") {
        //上门取件
        _this.orderForm.deliveryDetail.contractName = "";
        _this.orderForm.deliveryDetail.phone = "";
        _this.orderForm.deliveryDetail.country = "";
        _this.deliveryDetail.provinceId = "";
        _this.orderForm.deliveryDetail.province = "";
        _this.orderForm.deliveryDetail.provinceId = "";
        _this.orderForm.deliveryDetail.city = "";
        _this.orderForm.deliveryDetail.addressFirst = "";
      }
    },
    queryCountrys() {
      var _this = this;
      _this.$request1
        .get(
          '/countryfilter',
          {
            params: {
              channelId: _this.orderForm.productId
            },
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          if (response.status == 200 && response.data.success) {
            _this.initialDataCountry = response.data.data;
          } else {
            _this.$message.error("加载初始化数据失败");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    createFilter(queryString) {
      return restaurant => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    querySearchCountry(queryString, cb) {
      var restaurants = this.initialDataCountry;
      restaurants.forEach((d, i) => {
        d.value = d.nameEn;
      });
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      cb(results);
    },
    queryProvince(countryId) {
      var _this = this;
      _this.initialDataCountry.forEach((d, i) => {
        if (d.id == _this.shippingDetail.countryId) {
          _this.orderForm.shippingDetail.country = d.code;
        }
      });

      _this.$request1
        .get(
          '/province/' + countryId + '',
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          if (response.status == 200 && response.data.success) {
            _this.initialDataProvince = response.data.data;
          } else {
            _this.$message.error("加载初始化数据失败");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    queryProvinceOfChina() {
      var _this = this;
      _this.$request1
        .get(
          '/province/' + 1 + '',
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          if (response.status == 200 && response.data.success) {
            _this.initialDataProvinceChina = response.data.data;
          } else {
            _this.$message.error("加载初始化数据失败");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    queryCity(provinceId) {
      var _this = this;
      _this.initialDataProvince.forEach((d, i) => {
        if (d.id == _this.shippingDetail.provinceId) {
          _this.orderForm.shippingDetail.province = d.nameCn;
        }
      });
      _this.$request1
        .get(
          '/city/' + provinceId + '',
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          if (response.status == 200 && response.data.success) {
            _this.initialDataCity = response.data.data;
          } else {
            _this.$message.error("加载初始化数据失败");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    selectCity() {
      var _this = this;
      _this.initialDataCity.forEach((d, i) => {
        if (d.id == _this.shippingDetail.cityId) {
          _this.orderForm.shippingDetail.city = d.nameCn;
        }
      });
    },
    queryCityOfChina(provinceId) {
      var _this = this;
      _this.orderForm.deliveryDetail.city = "";
      _this.initialDataProvinceChina.forEach((d, i) => {
        if (d.id == _this.orderForm.deliveryDetail.provinceId) {
          _this.orderForm.deliveryDetail.province = d.nameCn;
        }
      });
      _this.$request1
        .get(
          '/city/' + provinceId + '',
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          if (response.status == 200 && response.data.success) {
            _this.initialDataCityChina = response.data.data;
          } else {
            _this.$message.error("加载初始化数据失败");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    buildingOrderForm() {
      //校验表单格式
      let _this = this;
      _this.orderForm.warehousCode = _this.currentWarehouseAddress.id;
      if (_this.fbaChecked) {
        // _this.orderForm.shippingDetail.contractName = "amazon";
        // _this.orderForm.shippingDetail.phone = "9999999999";
      }
      let _validHead = true;
      _this.$refs["orderForm1"].validate(valid => {
        if (!valid) {
          _validHead = false;
        }
      });

      let _validBody = true;
      _this.$refs["orderForm2"].validate(valid => {
        if (!valid) {
          _validBody = false;
        }
      });
      let _validBottom = true;
      _this.$refs["orderForm3"].validate(valid => {
        if (!valid) {
          _validBottom = false;
        }
      });

      if (
        !_this.orderForm.customerRefnumber.customerOrderNumber ||
        _this.orderForm.customerRefnumber.customerOrderNumber.length <= 0
      ) {
        _this.$message.error("客户单号必填");
        return false;
      }

      if (!_validHead || !_validBody || !_validBottom) {
        return false;
      }
      let _realTotalCount = 0;

      if (!_this.guigeArr || _this.guigeArr.length <= 0) {
        _this.$message.error("箱子信息和sku信息必填");
        return false;
      } else {
        let _checkout = true;

        _this.guigeArr.forEach((d, i) => {
          if (!d.skus || d.skus.length <= 0) {
            _checkout = false;
          }
          if (!d.number || d.number <= 0 || isNaN(d.number)) {
            _checkout = false;
          } else {
            _realTotalCount += parseInt(d.number);
          }
          if (!_this.formData.usMeasure) {
            if (d.long < 0) {
              _checkout = false;
            }
            if (d.width < 0) {
              _checkout = false;
            }
            if (d.height < 0) {
              _checkout = false;
            }
            if (d.weight < 0) {
              _checkout = false;
            }
          }
        });
        if (!_checkout) {
          _this.$message.error("箱子信息和sku信息必填,且箱明细数据必须大于0");
          return false;
        }
      }

      let _totalCarton = parseInt(_this.orderForm.packingList.totalCarton);
      var cartonDetails = new Array();

      //箱子规格不同_totalCarton
      if (_realTotalCount != _totalCarton) {
        _this.$message.error(
          "箱规格不相同时，界面上填的货物箱数必须和明细里填的货物箱数的总数一致。"
        );
        return false;
      }
      _this.guigeArr.forEach((d, i) => {
        let _number = parseInt(d.number);

        var item = new Array();
        d.skus.forEach((d, i) => {
          var obj = new Object();
          obj.sku = d.sku;
          obj.qty = d.number;
          item.push(obj);
        });

        for (let i = 0; i < _number; i++) {
          var cartonDetail = new Object();
          if (!_this.formData.usMeasure) {
            if (i == 0) {
              cartonDetail.cartonNumber = d.cartonNumber;
            }
            cartonDetail.customerCartonNumber = d.customerCartonNumber;
            cartonDetail.actuallyLength = parseFloat(d.long);
            cartonDetail.actuallyWidth = parseFloat(d.width);
            cartonDetail.actuallyHeight = parseFloat(d.height);
            cartonDetail.actuallyWeight = parseFloat(d.weight);

            cartonDetail.length = parseFloat(d.long);
            cartonDetail.width = parseFloat(d.width);
            cartonDetail.height = parseFloat(d.height);
            cartonDetail.weight = parseFloat(d.weight);
          } else {
            cartonDetail.cartonNumber = "";
            cartonDetail.actuallyLength = 0;
            cartonDetail.actuallyWidth = 0;
            cartonDetail.actuallyHeight = 0;
            cartonDetail.actuallyWeight = 0;
            cartonDetail.length = 0;
            cartonDetail.width = 0;
            cartonDetail.height = 0;
            cartonDetail.weight = 0;
          }
          cartonDetail.items = item;
          cartonDetails.push(cartonDetail);
        }
      });

      _this.orderForm.packingList.cartonDetails = cartonDetails;
      return true;
    },
    //提交订单
    editOrderSubmit() {
      let _this = this;
      if (!this.buildingOrderForm()) {
        return;
      }
      let editPostOrderData = this.orderFormToSubmitData(this.orderForm);
      this.$confirm("您确定要修改订单吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$request1({
            method: 'POST',
            url: '/order/' + this.editOrderId + '/edit/done',
            data: editPostOrderData,
            xhrFields: {
              withCredentials: true
            }
          })
            .then(function(res) {
              // console.log(res);
              if (res.data.success) {
                _this.$alert(
                  _this.editOrderId +
                    " 修改成功，如果需要补录费用，请到费用补录页面添加费用",
                  "提示",
                  {
                    confirmButtonText: "确定",
                    callback: action => {
                      if (_this.$route.query.from === "lastmile") {
                        _this.$router.push("/orderoperation/lastmileexpress");
                      } else if(_this.$route.query.issupp) {
                           _this.$router.push("/orderoperation/supplierorder");
                      } else {
                        _this.$router.push("/order");
                      }
                    }
                  }
                );
              } else {
                _this.$alert(res.data.message, "异常提示", {
                  confirmButtonText: "确定",
                  callback: action => {}
                });
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消修改"
          });
        });
    },

    orderFormToSubmitData(orderForm) {
      let appointmentAt = orderForm.deliveryDetail.appointmentAt;
      let oldTime = new Date(appointmentAt).getTime();
      let submitOrderData = {
        id: this.editOrderId,
        orgOp: orderForm.orgOp,
        warehouseCode: orderForm.warehousCode,
        orgOwner: orderForm.orgOwner,
        productId: orderForm.productId,
        remark: orderForm.remark,
        generalTrade: orderForm.generalTrade,
        purchaseInsurance: orderForm.purchaseInsurance,
        amazonReferenceId: orderForm.amazonReferenceId,
        audit: false,
        customerRefnumber: orderForm.customerRefnumber,
        deliveryDetail: {
          deliveryType: orderForm.deliveryDetail.deliveryType,
          address: {
            userId: "",
            name: "",
            phone: "",
            country: orderForm.deliveryDetail.country,
            province: orderForm.deliveryDetail.province,
            city: orderForm.deliveryDetail.city,
            address: orderForm.deliveryDetail.addressFirst,
            address2: "",
            zipcode: "",
            type: "",
            position: "",
            defaultAddress: false,
            fbaWarehouseCode: ""
          },
          warehouseCode: orderForm.deliveryDetail.warehouseCode,
          appointmentAt: oldTime,
          shipment: {
            provider: orderForm.deliveryDetail.expressCompany,
            trackingNumber: orderForm.deliveryDetail.expressNumber
          },
          contractDatail: {
            name: orderForm.deliveryDetail.contractName,
            phone: orderForm.deliveryDetail.phone
          }
        },
        shippingDetail: {
          address: {
            id: "",
            userId: "",
            name: "",
            phone: "",
            country: orderForm.shippingDetail.country,
            province: orderForm.shippingDetail.province,
            city: orderForm.shippingDetail.city,
            address: orderForm.shippingDetail.addressFirst,
            zipcode: orderForm.shippingDetail.zipcode,
            address2: orderForm.shippingDetail.addressSecond,
            type: "",
            position: "",
            defaultAddress: false,
            fbaWarehouseCode: orderForm.shippingDetail.fbaWarehouseCode,
            createDate: "",
            companyName: orderForm.shippingDetail.companyName
          },
          contractDatail: {
            name: orderForm.shippingDetail.contractName,
            phone: orderForm.shippingDetail.phone
          }
        },
        packingList: orderForm.packingList,
        editCarton: this.editCarton
      };
      return submitOrderData;
    },
    queryWarehouseData() {
      this.$request1({
        method: 'GET',
        url: '/warehouse/load',
        params:{
          orgOwner: this.orderForm.orgOwner
        },
        xhrFields: {
          withCredentials: true
        }
      })
        .then(response => {
          console.log(response.data.data)
          this.warehouseData = response.data.data;
          this.flag = true;
          if (this.warehouseData.length == 1) {
            this.flag = false;
          }
          // this.getMapForm(this.warehouseData[0]);
          
          this.warehouse = [];
          response.data.data.forEach((d, i) => {
            d.title = d.name;
            d.address = d.warehouseAddress.address;
            d.position = d.warehouseAddress.position.split(",");

            let warehouse = { id: "", title: "" };
            warehouse.id = d.id;
            warehouse.title = d.name;
            this.warehouse.push(warehouse);
          });
          this.initialDataWarehouseAddress = response.data.data;
          // this.warehouseId = this.warehouseData[0].id;

          let defaultWarehouse = this.warehouseData.find(item => {
            return item.id == this.default_warehousCode
          })
          if(defaultWarehouse) {
            this.warehouseId = defaultWarehouse.id
            this.getMapForm(defaultWarehouse);
          } else{
            this.warehouseId = this.warehouseData[0].id
            this.getMapForm(this.warehouseData[0]);
          }

          // this.currentWarehouseAddress = response.data.data[0];
        })
        .catch(error => {
          console.log(error);
        });
    },
    changeFbaWarehouseCode() {
      let _this = this;
      _this.initialDataFbaAddress.forEach((d, i) => {
        if (d.id == _this.orderForm.shippingDetail.fbaWarehouseCode) {
          _this.orderForm.shippingDetail.country = d.country;
          _this.orderForm.shippingDetail.province = d.state;
          _this.orderForm.shippingDetail.city = d.city;
          _this.orderForm.shippingDetail.zipcode = d.postCode;
          _this.orderForm.shippingDetail.addressFirst = d.address;
          _this.orderForm.shippingDetail.fbaWarehouseCode = d.warehouseCode;
          _this.orderForm.shippingDetail.contractName = d.contactPerson;
          _this.orderForm.shippingDetail.phone = d.contactNumber;

          _this.initialDataCountry.forEach((c, j) => {
            if (d.country == c.code) {
              _this.queryProvince(c.id);
            }
          });
          setTimeout(() => {
            _this.initialDataProvince.forEach((p, j) => {
              if (d.state == p.code || d.state == p.nameEn) {
                _this.queryCity(p.id);
              }
            });
          }, 500);
        }
      });
    },
    queryFbaAddress() {
      // console.log(">>>>> query fba address ");
      let _this = this;
      _this.$request1
        .get(
          '/warehouse-address/fba',
          {
            params: {
              channelId: _this.orderForm.productId
            },
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          if (response.status == 200 && response.data.success) {
            _this.initialDataFbaAddress = response.data.data;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    changeShippingAddressType() {
      let _this = this;
      if (!_this.fbaChecked) {
        _this.orderForm.shippingDetail.contractName = "";
        _this.orderForm.shippingDetail.phone = "";
      }
    },
    selectWarehouse() {
      this.warehouseData.forEach((item, index) => {
        if (item.id == this.warehouseId) {
          this.getMapForm(item);
          this.userCarry[0].title = item.name;
          this.userCarry[0].address = item.warehouseAddress.address;
          this.userCarry[0].name = item.receiptPersonName;
          this.userCarry[0].phone = item.phone;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#sp-amap {
  position: fixed;
  top: 0;
  right: 100%;
  &.isOpen {
    position: relative;
    right: 0;
  }
}
.sp-card-title {
  display: block !important;
}
.toggle-wrapper {
  margin-bottom: 15px;
  .el-button {
    margin-right: 30px;
  }
}
.must {
  position: relative;
  padding-left: 15px;
  &::before {
    position: absolute;
    left: 5px;
    top: 10px;
    display: block;
    content: "*";
    color: #f56c6c;
  }
}

.pickup-content{
  display: flex !important;
  flex-wrap: wrap;
  align-items: center;
  .pickup-button{
    width: 300px;
  }
  .pickup-address{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-left: 15px;
    li{
      margin-right: 15px;
    }
  }
}

.inline-flex{
  display: flex; 
  flex-wrap: wrap;
  >:first-child{
    margin-right: 15px;
  }
}

.input-group{
  width: 300px;
  display: flex; 
  flex-wrap: wrap;
  align-items: center;
  .size{
    width: 95px;
    &:not(:last-child) {
      margin-right: 6px;
    }
  }
}

.carton-table__content {
  padding: 0 120px;
}
</style>


// WEBPACK FOOTER //
// src/views/order/editorder.vue